//import { adobeEventTypes } from 'client/enums/adobe.types'

import { DATA_TRACK_TYPE_BANNER, DATA_TRACK_TYPE_CTA } from "./constants";

// Complete
const ATM_CONSTANTS = {
  domain: 'earnmore.bluerewards.ca',
  section: 'brs',
  url: 'https://earnmore.bluerewards.ca',
  locale: 'en',
  loginStatus: 'not_logged_in',
  categories: {
    popUp: 'pop-up',
    catalogue: 'catalogue',
    account: 'account',
    page: 'page',
  }
};

// Complete
const initAdobeDataLayer = (window) => {
  window.adobeDataLayer = !!window.adobeDataLayer ? window.adobeDataLayer : []
}

// Complete
const addAdobeDataEventListeners = () => {
  initAdobeDataLayer(window)
  window.addEventListener('click', onCTAClick)
}

// TODO: Refactor/Rename?
const pushObjToDataLayer = (data) => {
  window.adobeDataLayer.push({ ...data })
}

const getCollectorInfo = (user) => {
  if (user && user.collectorNumber) {
    return {
      id: user.collectorNumber,
      tier: user.visitInfo.tier,
      login_status: 'logged_in',
      points: user.visitInfo.balance || 0,
    };
  }

  return {
    id: '',
    tier: '',
    login_status: 'not_logged_in',
    points: 0,
  };
};

// Complete
const getSiteDetails = (window, locale) => {
  return {
    domain: ATM_CONSTANTS.domain,
    section: ATM_CONSTANTS.section,
    subsection: '',
    language: locale || 'en',
    screen_height: window.screen.height,
    screen_width: window.screen.width
  };
};

const getPageSectionValue = (processedSections, depth) => {
  if (processedSections.length < depth) {
    return '';
  }

  return constructAdobeString([ATM_CONSTANTS.section, ...processedSections.slice(0, depth)]);
};


/**
 * @param {Window} window
 * @param {{ pageCategory?: string, sections?: string[], title?: string }} [pageOptions]
 */
const getPageDetails = (window, pageOptions = {}) => {
  const {
    pageCategory = ATM_CONSTANTS.categories.catalogue,
    sections = [],
    title = '',
  } = pageOptions;

  const {
    location: {
      href: url = ATM_CONSTANTS.url
    },
  } = window;

  const processedSections = sections
    .filter(Boolean)
    .map(normalizeString);

  return {
    name: constructAdobeString([
      ATM_CONSTANTS.section,
      ...processedSections,
    ]),
    previousPageName: '',
    title,
    url,
    section: getPageSectionValue(processedSections, 1),
    subSection1: getPageSectionValue(processedSections, 2),
    subSection2: getPageSectionValue(processedSections, 3),
    subSection3: getPageSectionValue(processedSections, 4),
    category: pageCategory,
  };
};

/**
 * @param {Window} window
 * @param {object} user
 * @param {{
 *   isProductView?: boolean,
 *   locale?: string,
 *   pageCategory?: string,
 *   retailer?: object[],
 *   sections?: string[],
 *   title?: string
 * }} [pageOptions]
 */
const pushPageViewEvent = (window, user, pageOptions = {}) => {
  initAdobeDataLayer(window);

  const payload = {
    event: 'pageViews',
    web: {
      pageDetails: getPageDetails(window, pageOptions),
      siteDetails: getSiteDetails(window, pageOptions && pageOptions.locale),
      collector: getCollectorInfo(user),
      ...(pageOptions.retailer && { productListItems: getProductListItems(pageOptions.retailer) }),
      prodView: pageOptions.isProductView ? 1 : 0
    }
  };

  pushObjToDataLayer(payload);
};

// Flesh out - TODO include category and subCategory
const getProductListItems = (retailers = []) =>  {
  return retailers.map((retailer) => getATMRetailerData(retailer))
}

// TODO Refactor/Rename for Shops/Offers
const getATMRetailerData = (retailer) => {

  return retailer ? {
    SKU: retailer.slug || '',
    name: retailer.displayName || '',
    priceTotal: '',
    quantity: '',
    merchVars: {
      offerName: retailer.slug || '',
      offerPartnerName: retailer.slug || '',
      productType: 'shops',
      productPlacement: '',
      productSaved: 0
    }
  } : null
}

// Complete ??
const constructAdobeString = (parts = []) => {
  if (parts && parts.length > 0) {
    return parts.filter((part) => {
      return part && part !== ''
    }).join(':')
  }

  return ''
}

// TODO: Refactor/Rename 'cat'
const normalizeString = (cat) => {
  return cat && cat.replaceAll(' ', '_').replaceAll(',', '').toLowerCase() || undefined
}

// Complete??
const onCTAClick = (e) => {
  const element = e.target.closest('[data-track-type]')

  if (!element) {
    return
  }

  const { dataset = {}, href = '' } = element

  const {
    trackId,
    trackClick,
    trackType,
    trackLocation = '',
    trackBannerName
  } = dataset

  if (!trackId || !trackClick || (trackType === DATA_TRACK_TYPE_BANNER && !trackBannerName)) {
    return
  }

  const payload = {};

  switch (trackType) {
    case DATA_TRACK_TYPE_BANNER:
      payload.event = 'bannerClicks';
      payload.web = {
        banner: {
          linkName: trackId,
          bannerName: trackBannerName,
          bannerCategory: trackClick,
          bannerLocation: trackLocation,
        }
      };
      break;
    case DATA_TRACK_TYPE_CTA:
      payload.event = 'CTAClick';
      payload.web = {
        CTAClick: {
          linkName: trackId,
          linkLocation: trackClick,
          linkhref: href
        }
      };
      break;
    default:
      payload.event = 'internalLinkClick';
      payload.web = {
        internalLink: {
          linkName: trackId,
          linkLocation: trackClick,
          linkhref: href
        }
      };
  }

  window.adobeDataLayer.push(payload);
}

// TODO: Refactor
const pushAdobeGlobalEvent = (eventType, ...args) => {
  let eventData = {}
  // switch (eventType) {
  //   case adobeEventTypes.checkOutStep1:
  //   case adobeEventTypes.checkOutStep2:
  //   case adobeEventTypes.promoCodeApplied:
  //   case adobeEventTypes.promocodeNotApplicable:

  //     const checkoutEventData = {}
  //     const productListItems = getProductListItems(args[0])
  //     checkoutEventData.event = eventType
  //     checkoutEventData.web = {
  //       productListItems
  //     }
  //     eventData = checkoutEventData
  //     break

  //  default:
  // }

  window.adobeDataLayer.push(eventData);

}

export {
  ATM_CONSTANTS,
  onCTAClick,
  addAdobeDataEventListeners,
  pushPageViewEvent
}
